(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/game-list-new/assets/javascripts/game-list-column.js') >= 0) return;  svs.modules.push('/components/marketplace/game-list-new/assets/javascripts/game-list-column.js');

'use strict';

const _excluded = ["children", "className", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const GameListColumn = _ref => {
  let {
      children,
      className = '',
      style = {}
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return React.createElement("div", _extends({
    className: "game-list-column".concat(className ? " ".concat(className.trim()) : ''),
    style: style
  }, props), children);
};
setGlobal('svs.components.marketplace.gameListNew.GameListColumn', GameListColumn);

 })(window);